export enum EntregaGeral {
    Bairro = "Todos",
}